module.exports = __webpack_public_path__ + "86b2389fa562da6b9425271d1833d490.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Italic.woff
// module id = 355
// module chunks = 0